import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { isEqual } from "lodash";

import Input from "components/Input";

import classes from "./styles.module.scss";
import { createStructuredSelector } from "reselect";

const NameInput = React.memo(({ 
    nameField = {},
    value,
    setValue,
    placeholder,
    onClick,
    renameItem,
    actionKey,
    keyActions,
    onBlur = () => {},
    tabIndex,
}) => {
    const { name = "", validate = [], current = "", change: nameChange } = nameField;

    // Use this state if none provided by parent [value, setValue]
    const [nameValue, setNameValue] = useState(current);
    const [metaValue, setMeta] = useState({ invalid: false, error: "" });

    // Update field value when name edited from outside
    useEffect(() => {
        if (!setValue)
            setNameValue(current);
    }, [current]);

    const getInputValidation = (value) => {
        var metaObj = { invalid: false, error: "" };

        validate.forEach((validCheck) => {
            if (validCheck(value)) {
                metaObj = { invalid: true, error: validCheck(value) };
                return;
            }
        });

        return metaObj;
    };

    return (
        <span style={{ width: "100%" }} onClick={onClick}>
            <Input
                type="text"
                name={name}
                input={{
                    value: value || nameValue,
                    onChange: (value) => {
                        if (setValue)
                            setValue(value);
                        else
                            setNameValue(value);
                        setMeta(getInputValidation(value));
                    },
                }}
                className={classes.nameInput}
                placeholder={placeholder}
                meta={metaValue}
                hideLabel
                tabIndex={tabIndex}
                onBlurAction={async () => {
                    onBlur();
                    
                    if (!setValue && !isEqual(current, nameValue) && !metaValue.invalid) {
                        await renameItem({
                            field: name,
                            value: nameValue,
                            change: nameChange,
                        });
                    }
                    if (metaValue.invalid) {
                        if (setValue)
                            setValue(current);
                        else
                            setNameValue(current);
                        setMeta({ invalid: false, error: "" });
                    }
                }}
                actionKey={actionKey}
                onKeyAction={() => { if (!metaValue.invalid) keyActions(); }}
            />
        </span>
    );
}, isEqual);

const mapStateToProps = createStructuredSelector({});

const mapDispatchToProps = (dispatch) => ({
    renameItem: async ({ field, value, change }) => {
        //Stripping all characters except alphanumeric, white space, dash, underline, round brackets
        var strippedString = value.replace(/[^\w\s\-.)(]/gi, "");
        if (!!strippedString) {
            change(field, strippedString);
        }
    },
});

export default connect(mapStateToProps, mapDispatchToProps)(NameInput);
